import { colors } from 'src/design-tokens/primitives';

export const CHART_MAX_SERIES = 3;

export const CHART_PALETTE_POSITIVE = {
  1: [colors.blue[700]],
  2: [colors.blue[700], colors.blue[900]],
  3: [colors.blue[600], colors.blue[700], colors.blue[900]],
} as const satisfies Record<1 | 2 | 3, readonly string[]>;

export const CHART_PALETTE_NEGATIVE = {
  1: [colors.critical[700]],
  2: [colors.critical[500], colors.critical[700]],
  3: [colors.critical[400], colors.critical[500], colors.critical[700]],
} as const satisfies Record<1 | 2 | 3, readonly string[]>;

export const CHART_DIMENSIONS = {
  // Chart
  defaultHeight: 200,
  marginTop: 16,
  marginRight: 8,
  marginLeft: 0,
  marginBottom: 0,

  // Bar
  barGap: 2,
  barCornerRadius: 2,

  // XAxis
  xAxisLabelGap: 8,
  xAxisLabelHeight: 24,

  // YAxis
  yAxisLabelPaddingTop: 16,
  yAxisLabelPaddingBottom: 0,
} as const;

export const CHART_AXIS = {
  tickFontFamily: 'Barlow, IBM Plex Sans, system-ui, sans-serif',
  tickFontSize: 12,
  tickColor: colors.gray[500],
  zeroLineColor: colors.navy[200],
} as const;

export const CHART_VALUE_LABEL_TEXT = {
  fontFamily: CHART_AXIS.tickFontFamily,
  fontSize: CHART_AXIS.tickFontSize,
  fontWeight: 600,
  fill: colors.gray[900],
} as const;
